/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { HtmlHeadInclude } from '@msdyn365-commerce/core';

import { ISearchResultContainerViewProps } from './unbxd-search-result-container';
import MsDyn365 from '@msdyn365-commerce/core';
import queryString from 'query-string';

const defaultUnbxdSearchJs = 'https://sandbox.unbxd.io/stage-henrys-com700951507546414_search.js';
const defaultUnbxdSearchCss = 'https://sandbox.unbxd.io/stage-henrys-com700951507546414_search.css';

const updateMetaLink = (rel: string, href: string | null, force: boolean = false) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    const hasLink = force || !!document.querySelector(`a.msc-page-link[data-page-action="${rel}"]`);
    process.env.NODE_ENV === 'development' && console.log('refreshMetaLinks', rel, href, hasLink);
    if (href && hasLink) {
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', rel);
            link.setAttribute('href', href);
            document.head.appendChild(link);
        } else {
            link.setAttribute('href', href);
        }
    } else {
        link?.remove();
    }
};

const refreshMetaLinks = (force: boolean = false) => {
    process.env.NODE_ENV === 'development' && console.log('refreshMetaLinks');
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    const canonicalUrl = canonicalLink?.getAttribute('href');
    if (canonicalUrl) {
        const qry = queryString.parseUrl(canonicalUrl);

        const pageNo = Number.parseInt(qry.query.page as string, 10) || 1;

        if (pageNo === 2) {
            qry.query.page = null;
        } else {
            qry.query.page = `${pageNo - 1}`;
        }

        const prevUrl =
            pageNo > 1
                ? queryString.stringifyUrl(qry, {
                      skipNull: true
                  })
                : null;
        updateMetaLink('prev', prevUrl, force);

        qry.query.page = `${pageNo + 1}`;
        const nextUrl = queryString.stringifyUrl(qry, {
            skipNull: true
        });
        updateMetaLink('next', nextUrl, force);
    }
};

const SearchResultContainerView: React.FC<ISearchResultContainerViewProps> = props => {
    const { SearchResultContainer, unbxdSearchJs, unbxdSearchCss, categoryNames, context } = props;

    const jsUri = props.context.app.config.heiUnbxdSearchJs ?? unbxdSearchJs ?? defaultUnbxdSearchJs;
    const cssUri = props.context.app.config.heiUnbxdSearchCss ?? unbxdSearchCss ?? defaultUnbxdSearchCss;

    const { isBrowser } = MsDyn365;
    const [initialized, setInitialized] = React.useState(false);
    const divRef = React.useRef<HTMLDivElement>(null);

    const categoryId = context.request.urlTokens.recordId ?? null;
    const categoryArr = categoryNames ? categoryNames.join('>') : '';

    React.useEffect(() => {
        const div = divRef.current;

        // console.log('dev', 'unbxd', categoryArr, categoryId);
        if (!initialized && isBrowser && div) {
            setInitialized(true);

            const childDiv = document.createElement('div');
            childDiv.id = 'unbxd_main_container';
            div.appendChild(childDiv);

            if (categoryArr && categoryId) {
                const categoryScriptTag = document.createElement('script');
                const configObj = {
                    page_type: 'BOOLEAN',
                    page: categoryId,
                    id: Number.parseInt(categoryId, 10) ?? 0
                };

                categoryScriptTag.innerHTML = `let UnbxdAnalyticsConf = ${JSON.stringify(configObj)}`;
                div.appendChild(categoryScriptTag);
            }

            const scriptTag = document.createElement('script');
            scriptTag.async = true;
            scriptTag.src = jsUri;
            div.appendChild(scriptTag);

            if (isBrowser) {
                const clickHandler = (evt: MouseEvent) => {
                    process.env.NODE_ENV === 'development' &&
                        console.log('SearchResultContainerView', 'click', evt, window?.location?.href);
                    const tgt = evt.target as Element;
                    if (tgt.hasAttribute('data-page-action')) {
                        const currentSearch = window?.location?.search;
                        if (currentSearch) {
                            let counter = 10;
                            const checkUrl = () => {
                                const search = window?.location?.search;
                                if (search === currentSearch) {
                                    if (counter >= 0) {
                                        --counter;
                                        setTimeout(checkUrl, 100);
                                    }
                                } else {
                                    process.env.NODE_ENV === 'development' && console.log('SearchResultContainerView', search);

                                    const link = document.querySelector('link[rel="canonical"]');
                                    if (link) {
                                        const currentParams = queryString.parse(search);
                                        const linkParams = queryString.parseUrl(link.getAttribute('href') ?? '');

                                        const pageNo = Number.parseInt(currentParams.page as string, 10) || 1;

                                        if (pageNo === 1) {
                                            linkParams.query.page = null;
                                        } else {
                                            linkParams.query.page = currentParams.page;
                                        }

                                        const newParams = queryString.stringify(linkParams.query, {
                                            skipNull: true
                                        });

                                        const newUrl = newParams ? `${linkParams.url}?${newParams}` : linkParams.url;
                                        link.setAttribute('href', newUrl);

                                        refreshMetaLinks();
                                    }
                                }
                            };

                            setTimeout(checkUrl, 100);
                        }
                    }
                };

                process.env.NODE_ENV === 'development' && console.log('SearchResultContainerView', 'add event handler');
                div.addEventListener('click', clickHandler);

                return () => {
                    process.env.NODE_ENV === 'development' && console.log('SearchResultContainerView', 'remove event handler');
                    // div.removeEventListener('click', clickHandler);
                };
            }
        }

        return () => {};
    }, [isBrowser, initialized, categoryArr, categoryId]);

    React.useLayoutEffect(() => {
        if (isBrowser) {
            // froce to create prev/next link, before unbxd is renderred
            refreshMetaLinks(true);
        }
    }, [isBrowser]);

    return (
        <Module {...SearchResultContainer}>
            <div ref={divRef}></div>
            <HtmlHeadInclude>
                <link data-load-point='headEnd' rel='stylesheet' href={cssUri} />
            </HtmlHeadInclude>
        </Module>
    );
};

export default SearchResultContainerView;
